import {Base64Object} from '@coolcolduk/util';
import {deleteField} from 'firebase/firestore';
import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import uploadUserAvatar from '../../api/user/uploadUserAvatar';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useSetAvatar() {
  const setAvatarFn = useCallback(async (avatar?: Base64Object): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    const photoUrl = await uploadUserAvatar(uid, avatar);
    await updateUserDoc(uid, {photoUrl: photoUrl ?? deleteField()});
  }, []);

  const {loading, error, refetch} = useFunctionRun(setAvatarFn, {
    skipLoadOnMount: true,
  });

  return {
    setAvatar: refetch,
    loading,
    error,
  };
}
